export const VopStatus = {
  Ignored: 'Ignored',
  Verified: 'Verified',
  Unverified: 'Unverified',
  Forced: 'Forced',
} as const;
export type VopStatus = (typeof VopStatus)[keyof typeof VopStatus];
